enum Sections {
  coverDetails = 'coverDetails',
  switching = 'switching',
  makingAClaim = 'makingAClaim',
}

enum Topics {
  selfEmployed = 'selfEmployed',
  mulitipleJobs = 'multipleJobs',
  redundancy = 'redundancy',
  movingAbroad = 'movingAbroad',
  parentalLeave = 'parentalLeave',
  existingCondition = 'existingCondition',
  coverLength = 'coverLength',
  existingPolicy = 'existingPolicy',
  coverStart = 'coverStart',
  claimProcess = 'claimProcess',
  claimFee = 'claimFee',
}

export { Topics, Sections };
